import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router/router.index'
import vuetify from './plugins/vuetify'
import '@/scss/main.scss'
import store from './store/store._index'
import { VueMaskDirective } from 'v-mask'
import Notifications from 'vue-notification'
import AppInit from './plugins/plugin.app-init'
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
import i18n from './plugins/i18n'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)
Vue.use(VueFileAgent)
Vue.directive('mask', VueMaskDirective)
Vue.use(Notifications)
Vue.use(AppInit)

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App),
  async created() {
    await this.$store.dispatch('loadContactSettings')
    await this.$store.dispatch('loadHeaderSettings')
    await this.$store.dispatch('loadSaleButtonSettings')
    await this.$store.dispatch('loadFooterSettings')
  }
}).$mount('#app')
